import { ActionTree } from "vuex";
import propertyDocumentTypesStore from "./property-document-types.store";
import { IPropertyEditState } from "../property-states.store";
import { IListing } from "../../../../models/listing-base-model";
import { IPropertyDocumentModel } from "../../../../models/property";

const documentActions = <ActionTree<IPropertyEditState, any>>{
	[propertyDocumentTypesStore.Get.LIST_OF_PROPERTY_DOCUMENTS]: ({ getters, commit }, param: number) => {
		return getters.service['listOfPropertyDocuments'](param)
			.then((listingResult: IListing<IPropertyDocumentModel>) => {
				commit(propertyDocumentTypesStore.Set.LIST_OF_PROPERTY_DOCUMENTS, listingResult);
				return Promise.resolve(listingResult);
			})
			.catch(error => Promise.reject(error))
	}
}

export default documentActions;